module.exports = __webpack_public_path__ + "static/img/ai-music-homepage.05bc935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/ai-music-homepage.png
// module id = 4l84
// module chunks = 1